import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
import LoadingSpinner from "./loadingspinner";
import Grid from "../grid/grid";
const labelClass = css({
    whiteSpace: "nowrap",
    fontSize: "12px",
    fontWeight: "normal",
    lineHeight: "12px",
    color: getThemeColorVar("typo", "light"),
});
const valueClass = css({
    whiteSpace: "nowrap",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "24px",
    color: getThemeColorVar("typo", "default"),
});
const indicatorUpClass = css({
    color: getThemeColorVar("positive", "default"),
});
const indicatorDownClass = css({
    color: getThemeColorVar("negative", "default"),
});
export const LabeledValue = (props) => {
    let indicator = undefined;
    switch (props.indicator) {
        case "up":
            indicator = React.createElement("span", { className: cx(indicatorUpClass) }, "\u25b2");
            break;
        case "down":
            indicator = React.createElement("span", { className: cx(indicatorDownClass) }, "\u25bc");
            break;
    }
    return (React.createElement(Grid, { columns: 1 },
        React.createElement("div", { className: cx(labelClass) }, props.label),
        !props.updating && (React.createElement("div", { className: cx(valueClass) },
            React.createElement("span", null, props.children),
            indicator)),
        props.updating && (React.createElement("div", { className: cx(valueClass) },
            React.createElement(LoadingSpinner, { size: 24, color: "primary" })))));
};
export default LabeledValue;
//# sourceMappingURL=labeledvalue.js.map